import { useColorMode } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

const STORYBOOK_ATTR = 'data-sb-color-mode'

/**
 * Returns whether the current context is "dark" for styling.
 * Use when you need dark-mode styles that respect both Chakra's color mode
 * and an optional override (e.g. widget config), with a fallback for
 * Storybook's toolbar (data-sb-color-mode on body).
 */
export const useIsDark = (override?: 'light' | 'dark'): boolean => {
  const { colorMode } = useColorMode()
  const [sbDark, setSbDark] = useState(false)

  useEffect(() => {
    const el = document.body
    if (!el) return
    const check = () => setSbDark(el.getAttribute(STORYBOOK_ATTR) === 'dark')
    check()
    const obs = new MutationObserver(check)
    obs.observe(el, { attributes: true, attributeFilter: [STORYBOOK_ATTR] })
    return () => obs.disconnect()
  }, [])

  if (override !== undefined) return override === 'dark'
  // When Chakra explicitly says light, never show dark (light mode wins)
  if (colorMode === 'light') return false
  if (colorMode === 'dark') return true
  // Fallback for Storybook toolbar when context is ambiguous
  return sbDark
}
